import { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { SESSION_ID_URL_PARAM } from "../pages/Transition/Transition";
import { getLtiKeyFromStorages } from "../api";
import { LTIK_LS_KEY } from "../api";

export interface SessionData {
    userId: string;
    userIdLoaded: boolean;
    sessionId: string;
    sessionIdLoaded: boolean;
    postSurveyTimeInSeconds: number;
    postSurveyTimeLoaded: boolean;
}

export const SESSION_DATA_LS_KEY = "sessionData";

export const USER_ID_URL_PARAM = "userid";
export const POST_SURVEY_TIME_URL_PARAM = "postsurveytime";
export const DEFAULT_POST_SURVEY_TIME = 60; // 1 minute

export function useWithSessionData() {
    const [data, setData] = useState<SessionData>({
        userId: null,
        userIdLoaded: false,
        sessionId: null,
        sessionIdLoaded: false,
        postSurveyTimeInSeconds: DEFAULT_POST_SURVEY_TIME,
        postSurveyTimeLoaded: false,
    });
    
    useEffect(() => {
        const params = new URL(window.location.href).searchParams;
        const sessionData = localStorage.getItem(SESSION_DATA_LS_KEY);
        const sessionDataObject: SessionData = sessionData ? JSON.parse(sessionData) : null;
        // Data from Local Storage
        const userIdFromLocalStorage = sessionDataObject ? sessionDataObject.userId : null;
        const sessionIdFromLocalStorage = sessionDataObject ? sessionDataObject.sessionId : null;
        const postSurveyTimeInSecondsFromLocalStorage = sessionDataObject ? sessionDataObject.postSurveyTimeInSeconds : DEFAULT_POST_SURVEY_TIME;
        // Data from Query Params
        const queryUserId = params.get(USER_ID_URL_PARAM);
        const querySessionId = params.get(SESSION_ID_URL_PARAM);
        const queryPostSurveyTime = params.get(POST_SURVEY_TIME_URL_PARAM);
        // Final merged data: query > local storage > new uuid
        const newUserId = uuidv4();
        const userId = queryUserId || userIdFromLocalStorage || newUserId;
        const postSurveyTimeInSeconds = queryPostSurveyTime ? parseInt(queryPostSurveyTime) : (postSurveyTimeInSecondsFromLocalStorage || DEFAULT_POST_SURVEY_TIME);
        const sessionId = querySessionId || sessionIdFromLocalStorage || uuidv4();
        const newSessionData: SessionData = {
            userId: userId,
            userIdLoaded: true,
            sessionId: sessionId,
            sessionIdLoaded: true,
            postSurveyTimeInSeconds: postSurveyTimeInSeconds,
            postSurveyTimeLoaded: true,
        };
        // store data in local storage and state
        setData(newSessionData);
        localStorage.setItem(SESSION_DATA_LS_KEY, JSON.stringify(newSessionData));
    }, []);

    useEffect(() => {
        // Gets ltik from search params or local storage and stores it in local storage
        const ltik = getLtiKeyFromStorages()
        if (ltik) {
            localStorage.setItem(LTIK_LS_KEY, ltik);
        }
    }, []);

    function startNewSession() {
        // create new session id and store data in local storage and state
        const newSessionId = uuidv4();
        const newSessionData: SessionData = {
            ...data,
            sessionId: newSessionId,
        };
        localStorage.setItem(SESSION_DATA_LS_KEY, JSON.stringify(newSessionData));
        setData(newSessionData);
        return newSessionId;
    }
    
    return {
        userId: data.userId,
        userIdLoaded: data.userIdLoaded,
        sessionId: data.sessionId,
        sessionIdLoaded: data.sessionIdLoaded,
        postSurveyTimeInSeconds: data.postSurveyTimeInSeconds,
        postSurveyTimeLoaded: data.postSurveyTimeLoaded,
        startNewSession,
    }
    
}